angular.module('bbl.module.brand-settings', [
  'bbl.services',
  'bbl.module.brand-settings.routing',
  'bbl.module.brand-settings.controller',
]);

require('./brand-settings.style.less');
require('./brand-settings.controller');
require('./brand-settings.routing');



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/brand-settings/brand-settings.module.js
 ** module id = 382
 ** module chunks = 0
 **/